// assets/admin/src/components/LeadManager.js
import React from 'react';

export default function LeadManager({ leads }) {
  return (
    <div>
      <h2>Patient Leads</h2>
      <p>Lead Manager component coming soon.</p>
    </div>
  );
}
